/*
  XXL (5 okt 2026): laadt een sectie pas als de bezoeker in de buurt scrolt.
  De sectie staat in de eerste HTML als lege plek <xxl-lazy-section data-url="...?section_id=...">.
  Zodra die plek binnen ~1200px van het scherm komt, halen we de volledige sectie op via de
  Section Rendering API en vervangen we de inhoud van #shopify-section-<id>.
  Custom elements (featured-collection, product-tabs, product-form, ...) starten vanzelf zodra ze in de DOM staan.
*/
if (!customElements.get('xxl-lazy-section')) {
  class XxlLazySection extends HTMLElement {
    connectedCallback() {
      if (this._started) return;
      this._started = true;
      if (!('IntersectionObserver' in window)) {
        this.load();
        return;
      }
      this._io = new IntersectionObserver(
        (entries) => {
          if (entries.some((e) => e.isIntersecting)) {
            this._io.disconnect();
            this.load();
          }
        },
        { rootMargin: '1200px 0px 1200px 0px' }
      );
      this._io.observe(this);
    }

    disconnectedCallback() {
      if (this._io) this._io.disconnect();
    }

    async load(attempt = 1) {
      if (this._loading) return;
      this._loading = true;
      const id = this.dataset.sectionId;
      const host = document.getElementById('shopify-section-' + id);
      try {
        const res = await fetch(this.dataset.url, { credentials: 'same-origin' });
        if (!res.ok) throw new Error('HTTP ' + res.status);
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.getElementById('shopify-section-' + id);
        if (!host || !fresh) throw new Error('sectie niet gevonden');
        if (fresh.querySelector('xxl-lazy-section')) throw new Error('opgehaalde sectie is weer een lege plek');
        const known = new Set(Array.from(document.scripts, (s) => s.src).filter(Boolean));
        host.innerHTML = fresh.innerHTML;
        // Scripts die via innerHTML binnenkomen draaien niet; laad nieuwe externe scripts alsnog.
        host.querySelectorAll('script').forEach((old) => {
          if (old.src && known.has(old.src)) return;
          const s = document.createElement('script');
          Array.from(old.attributes).forEach((a) => s.setAttribute(a.name, a.value));
          if (!old.src) s.textContent = old.textContent;
          old.replaceWith(s);
        });
        host.dispatchEvent(new CustomEvent('xxl:section-loaded', { bubbles: true, detail: { id } }));
      } catch (err) {
        this._loading = false;
        if (attempt < 3) {
          setTimeout(() => this.load(attempt + 1), 1500 * attempt);
        } else {
          this.removeAttribute('aria-busy');
          this.classList.add('xxl-lazy-rail--failed');
          if (window.console) console.warn('xxl-lazy-section', id, err);
        }
      }
    }
  }
  customElements.define('xxl-lazy-section', XxlLazySection);
}
